export default __webpack_public_path__ + "static/media/schedule_appointment_header.f4e696e8.svg";